import { render, staticRenderFns } from "./InsightCustom.vue?vue&type=template&id=5ac34b10&scoped=true&"
import script from "./InsightCustom.vue?vue&type=script&lang=js&"
export * from "./InsightCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac34b10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ac34b10')) {
      api.createRecord('5ac34b10', component.options)
    } else {
      api.reload('5ac34b10', component.options)
    }
    module.hot.accept("./InsightCustom.vue?vue&type=template&id=5ac34b10&scoped=true&", function () {
      api.rerender('5ac34b10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/InsightCustom.vue"
export default component.exports